// extracted by mini-css-extract-plugin
export default {"container":"ScreenStatsGroup_container__HqesT"};